<digital-platform-header></digital-platform-header>
<mat-sidenav-container autosize>
  <mat-sidenav mode="side" #sidenav opened>
    <digital-platform-side-nav
      *ngIf="loggedIn$ | async"
      class="side-nav"
      [ngClass]="{ expanded: expanded }"
      ($adjustFlex)="adjustFlex($event)"
    ></digital-platform-side-nav>
  </mat-sidenav>
  <mat-sidenav-content>
    <!-- This is the placeholder for pageName, search bar, and advanced search button -->
    <div *ngIf="titleService.getPageName()" class="separator" fxLayout="row">
      <p class="page-name" fxLayoutAlign="start center">
        {{ titleService.getPageName() }}
      </p>
    </div>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- <div class="wrapper" *ngIf="!routeLoading" fxLayout="row" fxFlexFill>
  <div class="nav-wrapper" fxFlex="{{ expanded ? 15 : 3 }}">
    <digital-platform-side-nav
      ($adjustFlex)="adjustFlex($event)"
      class="side-nav"
    ></digital-platform-side-nav>
  </div>
  <main fxFlex="{{ expanded ? 85 : 97 }}">

    <div *ngIf="titleService.getPageName()" class="separator" fxLayout="row">
      <p class="page-name" fxLayoutAlign="start center">
        {{ titleService.getPageName() }}
      </p>
    </div>
    <router-outlet></router-outlet>
  </main>
</div> -->

<mat-spinner
  class="spinner"
  diameter="64"
  *ngIf="routeLoading && (loggedIn$ | async) === true"
></mat-spinner>

<!-- <div class="wrapper" *ngIf="(loggedIn$ | async) === false" fxLayout="row">
  <main fxFlex="100">
    <router-outlet></router-outlet>
  </main>
</div> -->

<digital-platform-footer></digital-platform-footer>
